import { Grid, Textarea } from "@mantine/core";
import { TranslateButton } from "ui";
import { UseFormReturnType } from "@mantine/form";
import { EventFormValues } from "./types";

interface EventFormDescriptionProps {
  form: UseFormReturnType<EventFormValues>;
  isPtFirst: boolean;
  t: (key: string) => string;
  handlePaste: (
    e: React.ClipboardEvent<HTMLTextAreaElement | HTMLInputElement>,
    field: keyof EventFormValues
  ) => void;
}

export const EventFormDescription = ({
  form,
  isPtFirst,
  t,
  handlePaste,
}: EventFormDescriptionProps) => {
  return (
    <>
      <Grid.Col span={6}>
        <Textarea
          mt="md"
          label={`${t("events.description")} (${isPtFirst ? "pt" : "en"})`}
          right="sm"
          maxRows={8}
          minRows={8}
          autosize
          {...form.getInputProps(isPtFirst ? "description_pt" : "description")}
          rightSection={
            <TranslateButton
              originalText={
                isPtFirst ? form.values.description : form.values.description_pt
              }
              tragetLang={isPtFirst ? "pt" : "en"}
              onTranslated={(translatedText) => {
                form.setFieldValue(
                  isPtFirst ? "description_pt" : "description",
                  translatedText
                );
              }}
            />
          }
          onPaste={(e) => {
            handlePaste(e, isPtFirst ? "description_pt" : "description");
          }}
          withAsterisk={form.values.published}
        />
      </Grid.Col>
      <Grid.Col span={6}>
        <Textarea
          mt="md"
          label={`${t("events.description")} (${isPtFirst ? "en" : "pt"})`}
          maxRows={8}
          minRows={8}
          autosize
          {...form.getInputProps(isPtFirst ? "description" : "description_pt")}
          rightSection={
            <TranslateButton
              originalText={
                isPtFirst ? form.values.description_pt : form.values.description
              }
              tragetLang={isPtFirst ? "en" : "pt"}
              onTranslated={(translatedText) => {
                form.setFieldValue(
                  isPtFirst ? "description" : "description_pt",
                  translatedText
                );
              }}
            />
          }
          onPaste={(e) => {
            handlePaste(e, isPtFirst ? "description" : "description_pt");
          }}
          withAsterisk={form.values.published}
        />
      </Grid.Col>
    </>
  );
};
